<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: "login-dialog",
    props:["isOpen"],
    data(){
      return{

      }
    },
    created(){
      this.check();
    },
    methods:{
      check(){
        if(this.isOpen){
          this.$messagebox.confirm("是否立即登录？").then(res=>{
            var store=this.$store;
            if(store.state.status.isIn){
              this.go(store.state.status.url + '?address=' + this.$route.path.replace(/\//g,'*'));
            }
            else{
              // this.$router.replace(store.state.status.url);
              this.$router.push(store.state.status.url);
            }
          },res=>{
            this.$emit("close");
          })
        }
      },
      go(url){
        location.href=url;
      }
    },
    watch:{
      isOpen(){
        this.check();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login-dialog/login-dialog.vue